// document.addEventListener('DOMContentLoaded', () => {
//   const drawer = document.getElementById('BottomDrawer');
//   const openDrawerButton = document.getElementById('OpenDrawer');
//   const closeDrawerButton = document.getElementById('CloseDrawer');

//   // Open Drawer
//   openDrawerButton.addEventListener('click', () => {
//     drawer.classList.add('open');
//   });

//   // Close Drawer
//   closeDrawerButton.addEventListener('click', () => {
//     drawer.classList.remove('open');
//   });

//   // Optional: Close drawer when clicking outside the content
//   drawer.addEventListener('click', (event) => {
//     if (event.target === drawer) {
//       drawer.classList.remove('open');
//     }
//   });
// });

$("body").on('click','#OpenDrawer',function(e){
    $("#BottomDrawer").addClass('open');
});

$("body").on('click','#BottomDrawer',function(e){
    $("#BottomDrawer").removeClass('open');
});

$("body").on('click','#CloseDrawer',function(e){
    $("#BottomDrawer").removeClass('open');
});

$("body").on('click','#OpenDrawerc',function(e){
  
    $("#BottomDrawerc").addClass('open');
});

$("body").on('click','#BottomDrawerc',function(e){
    $("#BottomDrawerc").removeClass('open');
});

$("body").on('click','#CloseDrawerc',function(e){
    $("#BottomDrawerc").removeClass('open');
});


